import {Injectable, inject} from '@angular/core'
import type {ActivatedRouteSnapshot} from '@angular/router'
import {StorageService} from '@services/storage.service'
import {NavigationService} from '../navigation.service'
import {SigninService} from '../signin.service'

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  readonly #storageService = inject(StorageService)
  readonly #navigationService = inject(NavigationService)
  readonly #signinService = inject(SigninService)

  async canActivate(route: ActivatedRouteSnapshot) {
    if (!this.#signinService.isAuthenticated()) {
      this.#storageService.reloadApp = true
      this.#navigationService.navigateRoot('auth')
      return false
    }

    return true
  }
}
